
<div class="d-flex flex-column justify-content-center align-items-center mt-4 text-body">
	<span class="fs-1 fw-bold">Anime/Manga Quiz</span>
</div>